import { useState, useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import { map, first } from 'lodash'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemText from '@mui/material/ListItemText'
import usePendingChangesProjects from '../../hooks/usePendingChangesProjects'
import PendingChangesModal from './PendingChangesModal'

function PendingChangesIndicator() {
  const { projects, pendingChangesCount, teamSlug } = usePendingChangesProjects()
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedProject, setSelectedProject] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)

  const menuOpen = Boolean(anchorEl)

  const handleClick = useCallback((event) => {
    if (pendingChangesCount === 1) {
      setSelectedProject(first(projects))
      setModalOpen(true)
    } else if (pendingChangesCount > 1) {
      setAnchorEl(event.currentTarget)
    }
  }, [pendingChangesCount, projects])

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  const handleProjectSelect = useCallback((project) => {
    setSelectedProject(project)
    setModalOpen(true)
    setAnchorEl(null)
  }, [])

  const handleModalClose = useCallback(() => {
    setModalOpen(false)
    setSelectedProject(null)
  }, [])

  if (pendingChangesCount === 0) {
    return null
  }

  return (
    <>
      <Button
        onClick={handleClick}
        variant="contained"
        size="small"
        sx={{
          bgcolor: 'pendingChanges.main',
          color: 'pendingChanges.contrastText',
          fontWeight: 600,
          '&:hover': {
            bgcolor: 'pendingChanges.light',
          },
        }}
      >
        <FormattedMessage
          id="navigation.pendingChanges.tooltip"
        />
        {` (${pendingChangesCount})`}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {map(projects, (project) => (
          <MenuItem key={project.id} onClick={() => handleProjectSelect(project)}>
            <ListItemText>{project.name}</ListItemText>
          </MenuItem>
        ))}
      </Menu>

      <PendingChangesModal
        open={modalOpen}
        onClose={handleModalClose}
        project={selectedProject}
        teamSlug={teamSlug}
      />
    </>
  )
}

export default PendingChangesIndicator
